(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-detail-popup"]) return;
  try {
    
  const productDetailPopup = document.querySelector('.product-detail-popup');
  const productCards = document.querySelectorAll('.product-bundle__items .product-card');
  const addToPackButton = document.querySelector('.product-detail-popup__add-to-pack');
  let currentProductTarget; // The product card that triggered this popup.

  if (!productDetailPopup || !productCards.length || !addToPackButton) {
    return;
  }

  // These elements are dynamically populated when this popup is triggered.
  const popupImage = productDetailPopup.querySelector('.product-detail-popup__image');
  const popupTitle = productDetailPopup.querySelector('.product-detail-popup__title');
  const popupMood = productDetailPopup.querySelector('.product-detail-popup__mood');
  const popupTagline = productDetailPopup.querySelector('.product-detail-popup__tagline');

  /**
   * Handles click events on product cards to display the product detail popup.
   *
   * @param {MouseEvent} e - The click event object.
   */
  const onProductCardClickHandler = (e) => {
    // Only clicking these elements will trigger the modal to open.
    const clickedOnImage = e.target.closest('.product-featured-image');
    const clickedOnProductType = e.target.closest('.product-card-type');
    const clickedOnProductTitle = e.target.closest('.product-card-title');

    if (!clickedOnImage && !clickedOnProductType && !clickedOnProductTitle) {
      return;
    }

    // Set the clicked product as the current product target.
    currentProductTarget = e.currentTarget;

    const {
      productImageUrl,
      productImageAlt,
      productTitle,
      productMood,
      productTagline
    } = e.currentTarget.dataset;

    if (popupImage) {
      popupImage.src = productImageUrl || '';
      popupImage.alt = atob(productImageAlt || '');
    }

    if (popupTitle) {
      popupTitle.textContent = atob(productTitle || '');
    }

    if (popupMood) {
      popupMood.textContent = atob(productMood || '');
    }

    if (popupTagline) {
      popupTagline.textContent = atob(productTagline || '');
    }

    const scrollableContainer = productDetailPopup.querySelector('.product-popup-modal__content-info');
    if (scrollableContainer) {
      scrollableContainer.scrollTop = 0;
    }

    productDetailPopup.show(e.target);
  };

  /**
   * Handles click events on the "Add to Pack" button within the product detail popup.
   * The click event is relayed to that product card's own "Add to Pack" button,
   * triggering the product's addition to the bundle.
   *
   * @param {MouseEvent} e - The click event object.
   */
   const onAddToPackClickHandler = (e) => {
    if (!currentProductTarget) {
      return;
    }

    const productCardAddToPackButton = currentProductTarget.querySelector(
      '.product-card--add-to-pack-button'
    );

    if (productCardAddToPackButton) {
      productCardAddToPackButton.click();
    }

    productDetailPopup.hide();
  };

  productCards.forEach((card) => {
    card.addEventListener('click', onProductCardClickHandler);
    card.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        onProductCardClickHandler(e);
      }
    });
  });

  addToPackButton.addEventListener('click', onAddToPackClickHandler);

  } catch(e) { console.error(e); }
})();
})();
